export default "__VITE_ASSET__3Z4c260E__"